import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
} from "redux/helpers/fetching"
import { fetchPurchasedProducts } from "redux/features/purchased_product/purchasedProductThunk"

const purchasedProductAdapter = createEntityAdapter()
export const initialState = purchasedProductAdapter.getInitialState({
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const purchasedProductSlice = createSlice({
  name: "purchased-product",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchPurchasedProducts.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchPurchasedProducts.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(fetchPurchasedProducts.fulfilled, (state, { payload }) => {
        purchasedProductAdapter.setAll(state, payload)
        handleCollectionFetchFulfilled(state)
      })
  },
})

export const { selectAll: selectPurchasedProducts } =
  purchasedProductAdapter.getSelectors(
    (state: RootState) => state.features.purchased_product,
  )
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.purchased_product.fetchCollectionStatus

export default purchasedProductSlice.reducer
